      document.addEventListener('click', function (e) {
        // OPEN
        const openBtn = e.target.closest('.view-similar-btn');
        if (openBtn) {
          const productId = openBtn.id.replace('view-', '');
          const targetCarousel = document.getElementById(`viewproduct-${productId}`);
          if (!targetCarousel) return;

          // Close all
          document.querySelectorAll('.viewsimilar-carousel').forEach((carousel) => {
            carousel.style.display = 'none';
            const parent = carousel.closest('.custom-view-similar-content');
            if (parent) parent.classList.remove('visible-drawer');
          });

          // Open selected
          targetCarousel.style.display = 'block';
          targetCarousel.style.opacity = '1';

          const parent = targetCarousel.closest('.custom-view-similar-content');
          if (parent) parent.classList.add('visible-drawer');
        }

        // CLOSE
        const closeBtn = e.target.closest('.view-smilar-close-btn');
        if (closeBtn) {
          const carousel = closeBtn.closest('.view-similar-container');
          if (!carousel) return;

          carousel.style.display = 'none';

          const parent = carousel.closest('.custom-view-similar-content');
          if (parent) parent.classList.remove('visible-drawer');
        }
      });